import { CLUSTER, FORCE_RU_LABELING } from '@/shared/config';

export const isRuCluster = (): boolean => CLUSTER === 'ru' || FORCE_RU_LABELING;
